// extracted by mini-css-extract-plugin
module.exports = {"Resume":"Resume_Resume__1axUt"};